import { render, staticRenderFns } from "./GuessInput.vue?vue&type=template&id=d20a9a88&scoped=true"
import script from "./GuessInput.vue?vue&type=script&lang=js"
export * from "./GuessInput.vue?vue&type=script&lang=js"
import style0 from "./GuessInput.vue?vue&type=style&index=0&id=d20a9a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20a9a88",
  null
  
)

export default component.exports